import { render, staticRenderFns } from "./ReportMealsSelectCompaniesField.vue?vue&type=template&id=f5a0f23a"
import script from "./ReportMealsSelectCompaniesField.vue?vue&type=script&lang=js"
export * from "./ReportMealsSelectCompaniesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports